import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAnKjtpQ5n9NnX8i1gm2S93v-elM-afiMY",
  authDomain: "toutorlhub.firebaseapp.com",
  projectId: "toutorlhub",
  storageBucket: "toutorlhub.firebasestorage.app",
  messagingSenderId: "65253300540",
  appId: "1:65253300540:web:2a44bea483b8945534e639",
  measurementId: "G-VTZYPE5X3L",
};
let messaging;
// Initialize Firebase
const app = initializeApp(firebaseConfig);
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered:");
    })
    .catch((error) => {
      console.error("Service Worker registration failed:");
    });
}

if ("serviceWorker" in navigator && "PushManager" in window) {
  messaging = getMessaging(app);
} else {
  console.warn("Push messaging is not supported in this browser.");
}

export { messaging };
